const { BaseCollection } = require('./_base.collection')

/**
 * @typedef SubscriptionModel
 * @property {string} id
 * @property {string} userId
 * @property {string} plan
 * @property {string} paymentMethod
 * @property {string} stripeSubscriptionId
 * @property {*} address
 * @property {*} startedAt
 */

/**
 * @extends {BaseCollection<SubscriptionModel>}
 */
class SubscriptionCollection extends BaseCollection {
  constructor() {
    super('SUBSCRIPTIONS')
  }

  /**
   * @param {string} userId
   * @returns {PromiseLike<AddressModel | null>}
   */
  findByUserId(userId) {
    return this.collection
      .where('userId', '==', userId)
      .orderBy('createdAt', 'desc')
      .limit(1)
      .get()
      .then((list) => (list.docs.length > 0 ? list.docs[0].data() : null))
  }

  /**s
   * @param {Object} param0
   * @param {string} param0.userId
   * @param {string} param0.plan
   * @param {string} param0.paymentMethod
   * @param {string=} param0.stripeSubscriptionId
   * @param {*} param0.address
   */
  async save({ userId, plan, paymentMethod, stripeSubscriptionId = null, address = null }) {
    await this.create({
      userId,
      plan,
      paymentMethod,
      stripeSubscriptionId,
      address,
      startedAt: new Date()
    })
  }
}

const subscriptionCollection = new SubscriptionCollection()

module.exports = {
  subscriptionCollection
}
